import logoSvg from '@/assets/logo.svg'
import gmsPng from '@/assets/gms.png'
import olosPng from '@/assets/olos.png'

export function getBrandAssets() {
  const whiteLabel = import.meta.env.VITE_PRODUCT_WHITE_LABEL

  if (whiteLabel === 'graphlogic') {
    return {
      logo: gmsPng,
      brandName: 'GMS',
    }
  }

  if (whiteLabel === 'olos') {
    return {
      logo: olosPng,
      brandName: 'Olos',
    }
  }

  return {
    logo: logoSvg,
    brandName: 'Intone',
  }
}

export function getDialerName() {
  const { brandName } = getBrandAssets()
  return brandName === 'Intone' ? 'Intone Dialer' : 'Dialer'
}

interface BaseConfig {
  id: number;
  name: string;
}

export function getConfigLabel (config: BaseConfig) {
  const isDefault = config.id === 1;
  return `${config.name}${isDefault ? " (Platform Default)" : ""}`;
}